import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { WalletListInterface } from '../../types/wallet-list';
import {
  WalletListFilter,
  defaultWalletListFilter,
} from '../../types/wallet-list-filter';

export const SENDER_WALLET_LIST_STATE = 'senderWalletList';

export interface SenderWalletListState {
  filter: WalletListFilter;
  dataSource: DataSource<WalletListInterface[]>;
}

export const initialDataSource: DataSource<WalletListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialSenderWalletListState: SenderWalletListState =
  Object.freeze({
    filter: defaultWalletListFilter,
    dataSource: {
      ...initialDataSource,
    },
  });
